import { ICommonValue } from "@components/global/new/CommonSelector/CommonSelector";
import { IMiningPlanOptions } from "@services/getMinerList";
import { dev } from "@utils/dev";

export interface IPlanItem {
  readonly id: number;
  readonly name: string;
}

export enum ContractPlanSelectorActions {
  SET_VALUES = "set_contract_and_plan",
  UPDATE_PLAN_VALUE_BY_ID = "update_plan_value_by_id",
}

export interface ContractPlanSelectorState {
  plans: IMiningPlanOptions[];
  currentContractId?: number;
  currentContractValue?: ICommonValue<number>;
  currentPlanValue?: ICommonValue<number>;
}

interface ContractPlanSelectorAction {
  readonly type: ContractPlanSelectorActions;
  readonly payload: Partial<ContractPlanSelectorState> | number;
}

const ContractPlanReducer = (
  state: ContractPlanSelectorState,
  action: ContractPlanSelectorAction
): ContractPlanSelectorState => {

  switch (action.type) {
    case ContractPlanSelectorActions.SET_VALUES:
      return {
        ...state,
        ...action.payload as Partial<ContractPlanSelectorState>
      }

    case ContractPlanSelectorActions.UPDATE_PLAN_VALUE_BY_ID:
      const planId = action.payload as number;
      const plan = state.plans.find(p => p.id === planId);
      if (plan) {
        return {
          ...state,
          currentPlanValue: {
            id: plan.id,
            text: plan.name
          } as ICommonValue<number>
        }
      }
      return {
        ...state,
      }

    default:
      return { ...state }
  }
}

export default ContractPlanReducer;